import axios from "axios"
import {
  IGetHospiceDetailsRequest,
  IGetHospiceDetailsResponse,
  IGetHospiceListResponse,
  IHospiceDetailsResponseTransformed,
} from "./hospice.model"

export const getHospiceList = async (url: string): Promise<IGetHospiceListResponse> => {
  const response = await axios.get<IGetHospiceListResponse>(url)

  return response.data
}

export const getHospiceDetails = async (
  url: string,
  data: IGetHospiceDetailsRequest,
): Promise<IHospiceDetailsResponseTransformed> => {
  const payload: IGetHospiceDetailsRequest = data

  const response = await axios.get<IGetHospiceDetailsResponse>(url, { params: payload })

  return response.data.hospice
}
